import store from '@/store'
import Cookie from 'js-cookie'
const env = require('../../env/index.js')
const { VUE_APP_CODE, VUE_APP_SPACECODE_CHAT, VUE_APP_SPACECODE_SEARCH, VUE_APP_SPACECODE_WRITE, VUE_APP_GATEWAY_COLLECTION, VUE_APP_USER_RESEARCH_IFRAME } = env

const sourceDict = {
    'chat': VUE_APP_SPACECODE_CHAT,
    'search': VUE_APP_SPACECODE_SEARCH,
    'write': VUE_APP_SPACECODE_WRITE,
}

import { forceReportBigData } from '@/utils/index.js'

function getBasicSystemInfo() {
    return window.pcmjssdk.asyncBrowerQuery('NEWPLUGIN_WRAPPLUGIN_GET_BASIC_SYSTEMINFO')
}

function GetAiStickVersion() {
    return window.pcmjssdk.asyncBrowerQuery('GetAiStickVersion')
}

function getSurveyRequestBody(source) {
    return new Promise((resolve, reject) => {
        Promise.all([getBasicSystemInfo(), GetAiStickVersion()]).then(([basicSystemInfo, aiStickVersion]) => {
            try {
                if (basicSystemInfo && aiStickVersion) {
                    basicSystemInfo = JSON.parse(basicSystemInfo)
                    resolve({
                        productInfo: {
                            code: VUE_APP_CODE,
                            spaceCode: `${VUE_APP_CODE}${sourceDict[source]}`,
                            channel: basicSystemInfo && basicSystemInfo.channel || '',
                            versionCode: aiStickVersion || ''
                        },
                        envInfo: {
                            isFull: 0,
                            isLock: 0,
                        },
                        deviceInfo: {
                            sn: basicSystemInfo && basicSystemInfo.sn || '',
                            mt: basicSystemInfo && basicSystemInfo.mtcode || '',
                            os: basicSystemInfo && basicSystemInfo.osName || '',
                            osBit: basicSystemInfo && basicSystemInfo.systemArch || '',
                            uuid: basicSystemInfo && basicSystemInfo.deviceid || '',
                            mac: basicSystemInfo && basicSystemInfo.mac || ''
                        }
                    })
                } else {
                    reject()
                }
            } catch (err) {
                throw Error(err)
            }
        }).catch(e => {
            reject(e)
        })
    })
}

function getSurveyInfo(source) {
    return new Promise((resolve, reject) => {
        getSurveyRequestBody(source)
            .then(requestBody => {
                return fetch(`${VUE_APP_GATEWAY_COLLECTION}/surveycontent/survey/product/info`, {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(requestBody)
                })
            })
            .then(res => res.json())
            .then(res => {
                if (!window.researchIframe?.showUserResaerchDialog) {
                    const script = document.createElement('script')
                    script.src = VUE_APP_USER_RESEARCH_IFRAME
                    document.body.appendChild(script)
                }
                resolve(res)
                // resolve({
                //     "status": 0,
                //     "message": null,
                //     "data": {
                //         "hasSurvey": 1,
                //         "surveyId": "51557",
                //         "surveyUrl": "https://research-sdk.mbgtest.lenovomm.com/#/Satisfaction?bizKey=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJwcmV2aWV3IjpmYWxzZSwic3VydmV5SWQiOiI1MTU1NyIsImlzUHJldmlldyI6MCwib3MiOiJXaW5kb3dzIDEwIFBybyIsInNuSGFzaCI6IjIxS1VBMDJGQ0RQRjU3UjZZUSIsIm10IjoiMjFLVSIsInRpdGxlIjoiIiwidXVpZCI6IjZBMUU5NENDLTJDN0MtMTFCMi1BODVDLUE0QkQyQjY4NEE5OSIsIm1hYyI6IjY4YzZhY2EwNDBlYyIsInZlcnNpb25Db2RlIjoiMi4yMSIsImlzTG9jayI6MCwibGVub3ZvSWQiOiIiLCJwcm9kdWN0Q29kZSI6InBjcnkiLCJvc0JpdCI6IjY0IiwiaXNGdWxsIjowLCJzbiI6IjIxS1VBMDJGQ0RQRjU3UjZZUSIsImV4cCI6MjM2NTY2NDQ5NSwidGFyZ2V0VXJsIjoiIiwiZGVzYyI6IiJ9.kZXeYaKUFfK4sTb7ZUdIGXNXjwd5fe5Sk5nwY153coU&surveyId=51557&sn=4c69b491dea93b24ba4ee183ade4bea17c9e2f26d4c7143ee2952ca56342f0a7&theme=white&mt=21KU&versionCode=2.21",
                //         "surveyType": "3"
                //     }
                // }) // 调试
            })
            .catch(() => {
                reject()
            })
    })
}

export function resetSurveyUrl() {
    store.commit('setSurveyJsUrl', '')
}

export function openSurveyDialog(from) {
    console.warn('........openSurveyDialog', from)
    if (store.state.surveyJsUrl) {
        // if (!window.researchIframe?.showUserResaerchDialog) {
        //     const script = document.createElement('script')
        //     script.src = VUE_APP_USER_RESEARCH_IFRAME
        //     document.body.appendChild(script)
        // }

        forceReportBigData('show', 'Diaoyan', 'frame', [
            {
                key: 'param2',
                value: JSON.stringify({
                    from,
                    type: '满意度调研'
                })
            }
        ])

        setTimeout(() => {
            window.researchIframe?.showUserResaerchDialog({ surveyJsUrl: store.state.surveyJsUrl }).then(() => {
                console.log('弹出成功')
            }).catch(() => {
                console.log('弹出失败')
            }).finally(() => {
                console.log('finally')
                resetSurveyUrl()
            })
        }, 1000)
    }
}

export function fetchSurveyUrl(source) {
    return new Promise((resolve, reject) => {
        getSurveyInfo(source).then(res => {
            console.warn('nps', res)
            if (res?.status === 0) {
                if (res.data?.hasSurvey && res.data?.surveyType === '3') {
                    store.commit('setSurveyJsUrl', res?.data?.surveyUrl)
                }
                resolve(res)
            } else {
                reject()
            }
        }).catch(() => {
            reject()
        })
    })
}

// --------------------
function convertToHttps(url) {
  try {
    const parsedUrl = new URL(url)
    if (parsedUrl.protocol === 'http:') {
      parsedUrl.protocol = 'https:'
    }
    return parsedUrl.toString()
  } catch (error) {
    console.error('Invalid URL:', error)
    return url // 无法解析时返回原 URL
  }
}
export async function handleInjectSurveyIntoMainFrame(from) {
    console.warn('..........handleInjectSurveyIntoMainFrame', from)
    try {
        const res = await isFirstExposureToday()
        console.warn('...........isFirstExposureToday', res, Cookie.get('isFirstExposureToday'))
        if (res && (res === true || res === 'true') && !Cookie.get('isFirstExposureToday')) {
            InjectSurveyIntoMainFrame(from)
            let date = Date.now()
            date += 1000 * 60 * 60 * 24
            date = new Date(new Date(date).getFullYear(), new Date(date).getMonth(), new Date(date).getDate())
            Cookie.set('isFirstExposureToday', '1', { expires: date })
        }
    } catch (error) {
        console.warn('isFirstExposureToday error', error)
    }
}

export function isFirstExposureToday() {
    return window.pcmjssdk.asyncBrowerQuery('IsFirstExposureToday')
}

export function InjectSurveyIntoMainFrame(from) {
    console.warn('...........InjectSurveyIntoMainFrame', from)
    const _window = window
    function getEnviromentConfig() {
        try {
            return JSON.parse(
                _window.pcmjssdk.callNative(
                    'NEWPLUGIN_WRAPPLUGIN_GETAPPENVIROMENTCONFIG',
                    ''
                )
            )
        } catch (e) {
            return {}
        }
    }
    const env = getEnviromentConfig().env
    let configs = {
        dev: {
            gateWay: 'https://cloud-rest.mbgtest.lenovomm.com',
            code: 'pcry',
            spaceCode: 'pcry1787'
        },
        test: {
            gateWay: 'https://cloud-rest.mbgtest.lenovomm.com',
            code: 'pcry',
            spaceCode: 'pcry1787'
        },
        prod: {
            gateWay: 'https://cloud-rest.lenovomm.com',
            code: 'pcry',
            spaceCode: 'pcry1039'
        }
    }
    let config = configs['prod']
    let contentDom = null
    let iframeDom = null
    if (env && configs[env]) {
        config = configs[env]
    }
    function distoryNpsDom() {
        if (contentDom) {
            document.documentElement.removeChild(contentDom)
            contentDom = null
            iframeDom = null
        }
    }
    function handleNpsDom(surveyUrl) {
        contentDom = document.createElement('div')
        contentDom.style.position = 'fixed'
        contentDom.style.zIndex = '9999'
        contentDom.style.right = '0'
        contentDom.style.bottom = '0'
        contentDom.style.width = '400px'
        contentDom.style.height = '170px'
        iframeDom = document.createElement('iframe')
        iframeDom.style.background = 'transparent'
        iframeDom.style.border = 'none'
        iframeDom.style.width = '100%'
        iframeDom.style.height = '100%'
        iframeDom.src = surveyUrl
        contentDom.appendChild(iframeDom)
        document.documentElement.appendChild(contentDom)
    }
    function handleSatisfactionDom(surveyJsUrl) {
        const script = document.createElement('script')
        script.src =
            'https://research-sdk.lenovomm.com/js/userResearch-iframe1.0.0.js'

        script.onload = function () {
            window.researchIframe &&
                window.researchIframe
                    .showUserResaerchDialog({ surveyJsUrl })
                    .then(res => {
                        console.log('弹出成功', res)
                    })
                    .catch(err => {
                        console.log('弹出失败', err)
                    })
        }
        document.body.appendChild(script)
    }
    function getSurveyRequestBody() {
        return new Promise((resolve, reject) => {
            Promise.all([getBasicSystemInfo(), GetAiStickVersion()])
                .then(([basicSystemInfo, aiStickVersion]) => {
                    try {
                        if (basicSystemInfo && aiStickVersion) {
                            basicSystemInfo = JSON.parse(basicSystemInfo)
                            resolve({
                                productInfo: {
                                    code: config.code,
                                    spaceCode: config.spaceCode,
                                    channel:
                                        (basicSystemInfo &&
                                            basicSystemInfo.channel) ||
                                        '',
                                    versionCode: aiStickVersion || ''
                                },
                                envInfo: {
                                    isFull: 0,
                                    isLock: 0
                                },
                                deviceInfo: {
                                    sn:
                                        (basicSystemInfo &&
                                            basicSystemInfo.sn) ||
                                        '',
                                    mt:
                                        (basicSystemInfo &&
                                            basicSystemInfo.mtcode) ||
                                        '',
                                    os:
                                        (basicSystemInfo &&
                                            basicSystemInfo.osName) ||
                                        '',
                                    osBit:
                                        (basicSystemInfo &&
                                            basicSystemInfo.systemArch) ||
                                        '',
                                    uuid:
                                        (basicSystemInfo &&
                                            basicSystemInfo.deviceid) ||
                                        '',
                                    mac:
                                        (basicSystemInfo &&
                                            basicSystemInfo.mac) ||
                                        ''
                                }
                            })
                        } else {
                            reject()
                        }
                    } catch (e) {
                        throw Error('调用nps错误')
                    }
                })
                .catch(e => {
                    reject(e)
                })
        })
    }
    function getSurvey() {
        return new Promise((resolve, reject) => {
            getSurveyRequestBody()
                .then(requestBody => {
                    return fetch(
                        `${config.gateWay}/surveycontent/survey/product/info`,
                        {
                            method: 'POST',
                            headers: {
                                'content-type': 'application/json'
                            },
                            body: JSON.stringify(requestBody)
                        }
                    )
                })
                .then(res => res.json())
                .then(res => {
                    resolve(res)
                })
                .catch(() => {
                    reject()
                })
        })
    }
    getSurvey().then(res => {
        console.warn('.........getSurvey', res)
        // res.data = {
        //     "hasSurvey": 1,
        //     "surveyId": "52047",
        //     "surveyUrl": "http://ue-h5.mbgtest.lenovomm.com/survey/freenps?bizKey=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJwcmV2aWV3IjpmYWxzZSwic3VydmV5SWQiOiI1MjA0NyIsImlzUHJldmlldyI6MCwib3MiOiJXaW5kb3dzIDEwIFBybyIsInNuSGFzaCI6IjIxS1VBMDJGQ0RQRjU3UjZZUSIsIm10IjoiMjFLVSIsInRpdGxlIjoiIiwidXVpZCI6IjZBMUU5NENDLTJDN0MtMTFCMi1BODVDLUE0QkQyQjY4NEE5OSIsIm1hYyI6IjY4LWM2LWFjLWEwLTQwLWVjIiwidmVyc2lvbkNvZGUiOiIyLjQ2IiwiaXNMb2NrIjowLCJsZW5vdm9JZCI6IiIsInByb2R1Y3RDb2RlIjoicGNyeSIsIm9zQml0IjoiNjQiLCJpc0Z1bGwiOjAsInNuIjoiMjFLVUEwMkZDRFBGNTdSNllRIiwiZXhwIjoyMzgzODAzODcwLCJ0YXJnZXRVcmwiOiIiLCJkZXNjIjoiIn0.jU0mm78B-120wnnHjFZxagKCR-JlJdoM6y5OLwAiAjw&surveyId=52047&sn=4c69b491dea93b24ba4ee183ade4bea17c9e2f26d4c7143ee2952ca56342f0a7&theme=white&mt=21KU&versionCode=2.46",
        //     "surveyType": "1"
        // }
        if (res && res.status === 0 && res.data && res.data) {
            const { hasSurvey, surveyUrl, surveyType } = res.data
            if (hasSurvey) {
                const httpsUrl = convertToHttps(surveyUrl)
                console.warn('..........httpsUrl', httpsUrl)
                if (surveyType === '1' || surveyType === '2') {
                    handleNpsDom(httpsUrl)
                    _window.pcmjssdk.reportBigdata.reportShowBigdata(
                        'Diaoyan',
                        '',
                        [
                            {
                                key: 'param2',
                                value: JSON.stringify({
                                    type: surveyType,
                                    from
                                })
                            }
                        ]
                    )
                } else if (surveyType === '3') {
                    handleSatisfactionDom(httpsUrl)
                }
            }
        }
    })
    window.addEventListener('message', function (e) {
        if (e && e.data) {
            try {
                const data = JSON.parse(e.data)
                if (data && data.msg && data.msg === 'NPS_MESSAGE_REQ_CLOSE') {
                    distoryNpsDom()
                }
            } catch (error) {
                console.log(error)
            }
        }
    })
}
